<template>
  <div id="digital-flop">
    <div
      :key="item.title"
      @click="clickTitle(item.title)"
      class="digital-flop-item"
      v-for="item in digitalTopData"
    >
      <div class="digital-flop-title">{{ item.title }}</div>
      <div class="digital-flop">
        <dv-digital-flop
          :config="item.number"
          style="width:100px;height:50px;"
        />
        <div class="unit">{{ item.unit }}</div>
      </div>
    </div>

    <dv-decoration-10/>
  </div>
</template>

<script>

  export default {
    name: 'DigitalTop',
    data() {
      return {
        digitalTopData: [],
        titleEng: [],
      }
    },
    methods: {
      /**
       * 根据最新遥测数据 进行排序
       * @param deviceId
       * @param deciveKey
       */
      getDigitalTop(response) {
        //无数据 原始数据清空
        if (response === 'false' || JSON.stringify(response) == "{}") {
          this.digitalTopData = [];
          return;
        }
        this.titleEng = [];
        //数据存在 设置样式
        //初期化
        let arrListResponse = [];
        let levelRefer = localStorage.getItem('levelRefer'); //获取设置水位值
        let snowRefer = localStorage.getItem('snowRefer');//获取设置雪深值
        let emptyHRefer = localStorage.getItem('emptyHRefer');//获取设置空高值
        let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声值
        let HIFlg = localStorage.getItem("HI") === "HI" ? true : false;
        let TGFlg = localStorage.getItem("TG") === "TG" ? true : false;
        let WDFlg = localStorage.getItem("WD") === "WD" ? true : false;
        //遍历数组添加到数组
        for (let obj in response) {
          let lang = {};
          let arrList = {};
          arrList.name = this.$t(obj).replace(',',' ');
          lang.ch = this.$t(obj).split(',')[0];
          lang.en = obj;
          arrList.ts = response[obj][0].ts;
          if(obj == 'level' || obj == 'Rwater' || obj == 'waterlevel') { //当前为水位属性
            arrList.value = (Math.abs(parseFloat(levelRefer) + parseFloat(response[obj][0].value))).toFixed(4).toString();
          } else if(obj == 'snowHeight' || obj == 'snowheight') {
            arrList.value = (Math.abs(parseFloat(snowRefer) + parseFloat(response[obj][0].value))).toFixed().toString();
          } else if(obj == 'emptyH' && !(emptyHRefer.toString() == '0')) {
            arrList.value = response[obj][0].value;
            let level = (parseFloat(emptyHRefer) - parseFloat(response[obj][0].value)) < 0 ? 0 : parseFloat(emptyHRefer) - parseFloat(response[obj][0].value);
            let flowNum =  (level *2399.5).toFixed(4).toString();
            arrListResponse.push({
              name: '瞬时流量 L/dm³',
              value: flowNum,
              ts: response[obj][0].ts
            })
          } else if(obj == 'flowNum') {
            arrList.value = (parseFloat(response[obj][0].value) * 6.28).toFixed(2);
          }  else if(obj == 'noise' || obj == 'noi' || obj == 'noise1' || obj == 'noise2') {
            arrList.value = (Math.abs(parseFloat(noiseRefer) + parseFloat(response[obj][0].value))).toFixed(1).toString();
          } else if(obj == 'Weather') {
            switch (parseInt(response[obj][0].value)) {
              case 0:
                arrList.value = "晴";
                break;
              case 16:
                arrList.value = "大雨";
                break;
              case 17:
                arrList.value = "中雨";
                break;
              case 18:
                arrList.value = "小雨";
                break;
              case 32:
                arrList.value = "大毛毛雨";
                break;
              case 33:
                arrList.value = "中毛毛雨";
                break;
              case 34:
                arrList.value = "小毛毛雨";
                break;
              case 50:
                arrList.value = "大雪";
                break;
              case 51:
                arrList.value = "中雪";
                break;
              case 52:
                arrList.value = "小雪";
                break;
              case 64:
                arrList.value = "烟";
                break;
              case 80:
                arrList.value = "雾";
                break;
              case 96:
                arrList.value = "冰雪或高空坠物";
                break;
              case 153:
                arrList.value = "飞虫或异常遮挡";
                break;
            }
          } else if((obj == 'ammoniaIon')) {//氨氮
            if(response.hasOwnProperty('waterPH')) {
              let amnitro = parseFloat(response[obj][0].value);
              let waterPH = parseFloat(response['waterPH'][0].value);
              if(response.hasOwnProperty('waterT')) {
                let waterT = parseFloat(response['waterT'][0].value);
                let result = amnitro * Math.pow(10, waterPH - (-0.032 * waterT + 10.042)) + amnitro;
                let amnitroResult = result.toFixed(2);
                arrList.value = amnitroResult;
              } else {
                let result = amnitro * Math.pow(10, (waterPH - 9.25)) + amnitro;
                let amnitroResult = parseFloat(result).toFixed(2);
                arrList.value = amnitroResult;
              }
            } else {
              arrList.value = response[obj][0].value;
            }

          } else if( HIFlg == true && obj == 'ambientHumidity') {
            arrList.value = response[obj][0].value;
            if(response.hasOwnProperty('ambientTemperature')) {
              let T = response['ambientTemperature'][0].value;
              let RH = response['ambientHumidity'][0].value;
              let HI = this.calculateHeatIndex(T, RH).toFixed(3);
              arrListResponse.push({
                name: '热量指数',
                value: HI,
                ts: response[obj][0].ts
              })
            }
          } else if(TGFlg == true && obj == 'ambientTemperature') {
            arrList.value = response[obj][0].value;
            if(response.hasOwnProperty('ambientHumidity') && response.hasOwnProperty('windSpeed')) {
              let temp = parseFloat(response['ambientTemperature'][0].value);
              let hum = parseFloat(response['ambientHumidity'][0].value);
              let speed = parseFloat(response['windSpeed'][0].value);
              let AT = this.calculateAT(temp, hum, speed).toFixed(2);
              arrListResponse.push({
                name: this.$t('AT').replace(',',' '),
                value: AT,
                ts: response[obj][0].ts
              })
            }

          } else if(WDFlg == true && obj == 'windDirection') {
            arrList.value = response[obj][0].value + ".0";
          } else if(obj == 'Rday1') {
            arrList.value = (parseFloat(response[obj][0].value )* 0.36).toFixed(2);
          } else {// 当前为非水位属性
            arrList.value = response[obj][0].value;
          }
          arrListResponse.push(arrList);
          this.titleEng.push(lang);
        }
        //倒序排序
        arrListResponse.sort(function (a, b) {
          return b.ts < a.ts ? -1 : 1
        });
        //设置数字翻牌器样式
        this.setDigitalTopData(arrListResponse.slice(0, 10));
        console.log("DigitalInfo", this.digitalTopData);
      },

      calculateHeatIndex(T, RH) {
        // 系数定义
        const c1 = -42.379;
        const c2 = 2.04901523;
        const c3 = 10.14333127;
        const c4 = -0.22475541;
        const c5 = -0.00683783;
        const c6 = -0.05481717;
        const c7 = 0.00122874;
        const c8 = 0.00085282;
        const c9 = -0.00000199;

        // 热量指数计算
        let HI = c1 + (c2 * T) + (c3 * RH) + (c4 * T * RH) + (c5 * T * T) + (c6 * RH * RH) +
          (c7 * T * T * RH) + (c8 * T * RH * RH) + (c9 * T * T * RH * RH);

        return HI;
      },

      calculateAT(temp, hum, speed) {
        let e = hum/100*6.105*2.71828*17.27*temp/(237.7+temp);
        let AT = 1.07*temp+0.2*e-0.65*speed-2.7;
        return AT;
      },

      /**
       * 获取点击选中的值
       * @param title
       */
      clickTitle(title) {
        if(title == '热量指数') {
          this.$emit("callBackInfo", '热量指数');
        } else if(title == 'H.S.T AT ℃') {
          this.$emit("callBackInfo", 'AT');
        } else {
          for (let i = 0; i < this.titleEng.length; i++) {
            if (this.titleEng[i].ch === title.split(' ')[0]) {
              let selectKey = [{ch: this.titleEng[i].ch, en: this.titleEng[i].en}];
              this.$emit("callBackInfo", selectKey);
              break;
            }
          }
        }
      },

      /**
       * 设置数字翻牌器样式
       * @param digitalData
       */
      setDigitalTopData(digitalData) {
        //初期化清空
        this.digitalTopData = [];
        //设置初期化颜色
        let color = '';
        //循环获取每一个对象
        for (let i = 0; i < digitalData.length; i++) {

          //设置数字颜色，三个为一个循环
          color = (i % 3 === 0 ? '#4d99fc' : (i % 3 === 1 ? '#f46827' : '#07CE14'));

          //设置每一个json对象样式
          let digital = {
            title: digitalData[i].name, //name
            number: {
              content:  digitalData[i].value,
              textAlign: 'center',
              style: {
                fill: color,
                fontWeight: 'bold',
                fontSize: '20'
              },
            },
            // unit: '公里'//单位后续补充
          };
          //将每个json添加到数组中
          this.digitalTopData.push(digital)
        }
      },
    },
  }
</script>

<style lang="less">
  @import "less/digitalFlop.less";
</style>



// WEBPACK FOOTER //
// src/components/DigitalTop.vue